import { render, staticRenderFns } from "./estatusPromocion.vue?vue&type=template&id=583c97fa&scoped=true"
import script from "./estatusPromocion.vue?vue&type=script&lang=js"
export * from "./estatusPromocion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c97fa",
  null
  
)

export default component.exports